// Manual type augmentation for POST /api/v1/sharepoint/search.
//
// The openapi schema (src/lib/api/schema.d.ts) is auto-generated from a
// running backend via `npm run generate:api`. Until the backend is running
// against this worktree's branch, the new endpoint is not present in the
// generated schema. These hand-written types MUST match
// `SharePointSearchResponse` in backend/app/api/sharepoint.py. Re-run
// `npm run generate:api` once the backend is live to replace this file.

export type SearchResultKind = "site" | "folder";
export type SearchResultSource = "sharepoint" | "onedrive";

export const SEARCH_MODE_FULL = "full" as const;
export const SEARCH_MODE_SITES_ONLY = "sites_only" as const;
export type SearchMode = typeof SEARCH_MODE_FULL | typeof SEARCH_MODE_SITES_ONLY;

export interface SearchResultItem {
  id: string | null;
  kind: SearchResultKind;
  name: string;
  web_url: string | null;
  breadcrumb: string;
  depth: number;
  rank: number;
  score: number;
  source: SearchResultSource;
  site_id: string | null;
}

export interface SharePointSearchResponse {
  query: string;
  search_mode: SearchMode;
  results: SearchResultItem[];
  total: number;
}
